var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: ['container wide-banner', _vm._isMobile() ? 'mobile' : '']
  }, [_c('Header'), _c('div', {
    staticClass: "banner-wrap"
  }, [_c('Banner')], 1), _c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "sec-wrap"
  }, [_c('div', {
    staticClass: "sec-content"
  }, [_c('a-row', {
    staticClass: "zhuanti",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8,
      "xl": 8
    }
  }, [_c('div', {
    staticClass: "zhuanti-item animate__animated animate__fadeIn"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/course/list',
        query: {
          type: 7
        }
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/paint.png")
    }
  })])], 1)]), _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8,
      "xl": 8
    }
  }, [_c('div', {
    staticClass: "zhuanti-item animate__animated animate__fadeIn"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/course/list',
        query: {
          type: 5
        }
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/ai.png")
    }
  })])], 1)]), _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8,
      "xl": 8
    }
  }, [_c('div', {
    staticClass: "zhuanti-item animate__animated animate__fadeIn"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/course/list',
        query: {
          type: 6
        }
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/kejiguan.png")
    }
  })])], 1)])], 1)], 1)]), _c('div', {
    staticClass: "sec-wrap"
  }, [_c('div', {
    staticClass: "sec-content"
  }, [_vm._m(0), _c('div', {
    staticClass: "sec-list"
  }, [_c('router-link', {
    staticClass: "see-more",
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "to": {
        path: '/course/list',
        query: {
          type: 5
        }
      }
    }
  }, [_vm._v("\n              查看更多>>\n         ")]), _c('a-list', {
    attrs: {
      "grid": {
        gutter: _vm._isMobile() ? 12 : 24,
        lg: 4,
        md: 3,
        sm: 2,
        xs: 1
      },
      "dataSource": _vm.courseList5,
      "pagination": _vm.pagination
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {}, [_c('a-card', {
          staticStyle: {
            "height": "250px"
          },
          attrs: {
            "bordered": false
          },
          on: {
            "click": function click($event) {
              return _vm.toDetail(item);
            }
          }
        }, [_c('div', {
          staticClass: "img-zoom"
        }, [_c('img', {
          staticClass: "cover",
          attrs: {
            "src": item.courseCover_url,
            "alt": ""
          }
        })]), _c('h3', {
          staticClass: "title"
        }, [_vm._v(_vm._s(item.courseName))])])], 1);
      }
    }])
  })], 1)])]), _c('div', {
    staticClass: "sec-wrap"
  }, [_c('div', {
    staticClass: "sec-content"
  }, [_vm._m(1), _c('div', {
    staticClass: "sec-list"
  }, [_c('router-link', {
    staticClass: "see-more",
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "to": {
        path: '/course/list',
        query: {
          type: 6
        }
      }
    }
  }, [_vm._v("\n              查看更多>>\n         ")]), _c('a-list', {
    attrs: {
      "grid": {
        gutter: _vm._isMobile() ? 12 : 24,
        lg: 4,
        md: 3,
        sm: 2,
        xs: 1
      },
      "dataSource": _vm.courseList6,
      "pagination": _vm.pagination
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {}, [_c('a-card', {
          staticStyle: {
            "height": "250px"
          },
          attrs: {
            "bordered": false
          },
          on: {
            "click": function click($event) {
              return _vm.toDetail(item);
            }
          }
        }, [_c('div', {
          staticClass: "img-zoom"
        }, [_c('img', {
          staticClass: "cover",
          attrs: {
            "src": item.courseCover_url,
            "alt": ""
          }
        })]), _c('h3', {
          staticClass: "title"
        }, [_vm._v(_vm._s(item.courseName))])])], 1);
      }
    }])
  })], 1)])])]), _c('a-back-top'), _c('Footer')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "sec-title"
  }, [_c('h1', {
    staticClass: "sec-title"
  }, [_vm._v("人工智能云学习")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "sec-title"
  }, [_c('h1', {
    staticClass: "sec-title"
  }, [_vm._v("科技场馆云探索")])]);
}];
export { render, staticRenderFns };